import { create } from "zustand";

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Renders the confirm button in a destructive (red) style. */
  danger?: boolean;
}

interface ConfirmState {
  open: boolean;
  options: ConfirmOptions | null;
  resolve: ((value: boolean) => void) | null;
  request: (options: ConfirmOptions) => Promise<boolean>;
  resolveWith: (value: boolean) => void;
}

export const useConfirmStore = create<ConfirmState>((set, get) => ({
  open: false,
  options: null,
  resolve: null,
  request: (options) =>
    new Promise<boolean>((resolve) => {
      set({ open: true, options, resolve });
    }),
  resolveWith: (value) => {
    const { resolve } = get();
    set({ open: false, options: null, resolve: null });
    resolve?.(value);
  },
}));

/**
 * Imperative confirm — usable from any event handler:
 *   if (!(await confirm({ message: "Delete this file?", danger: true }))) return;
 */
export const confirm = (options: ConfirmOptions): Promise<boolean> =>
  useConfirmStore.getState().request(options);
